import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  GET_DELIVERYS_REQUESTED,
  EDIT_DELIVERYS_REQUESTED,
  GET_DELIVERYS_SUCCEEDED, GET_DELIVERY_USER_DATA_REQUESTED, GET_DELIVERY_USER_DATA_SUCCEEDED
} from './edit.actions';
import {UtilityService} from "../../../common/services/utility/utility.service";
import {NotificationService} from "../../../common/services/notification/notification.service";
import {WIZARD_PRODUCT_SKIP_COMPLETED} from "../../product/wizard/wizard.actions";
import {COLLECTION_COMP} from "../../collection/collection.const";

function* editDeliverys(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.delivery.update(action.data).toPromise();
    const router = AppInjector.get(Router);
    AppInjector.get(NotificationService).show('success', 'Delivery updated', 5000);
    let redirect = 'delivery/list';
    if (action.redirect) {
      redirect = action.redirect;
    }
    if (!action.noredirect) {
      AppInjector.get(UtilityService).reset();
      router.navigate([redirect], {queryParams: {untouched: true, ...(action.queryParams ? action.queryParams : {})}});
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchEditDeliveryRequest() {
  yield takeEvery(EDIT_DELIVERYS_REQUESTED, editDeliverys);
}
function* getDeliverys(action) {
  const api = AppInjector.get(ApiService);
  try {
    let data = yield api.delivery.getItemById(action.id).toPromise();
    yield put({ type: GET_DELIVERYS_SUCCEEDED, data });
    yield put({ type: GET_DELIVERY_USER_DATA_REQUESTED, data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchAddDataDeliveryRequest() {
  yield takeEvery(GET_DELIVERYS_REQUESTED, getDeliverys);
}

function* getDeliveryUserData(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = null;
    if (action.data.object_type === 'collection') {
      result = yield api.collection.getItemById(action.data.object_id).toPromise();
    } else if (action.data.object_type === 'product') {
      result = yield api.product.getItemById(action.data.object_id).toPromise();
    }
    yield put({ type: GET_DELIVERY_USER_DATA_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetDeliveryUserDataRequest() {
  yield takeEvery(GET_DELIVERY_USER_DATA_REQUESTED, getDeliveryUserData);
}


export default [watchEditDeliveryRequest, watchAddDataDeliveryRequest, watchGetDeliveryUserDataRequest];
